import { render } from "./Layout.vue?vue&type=template&id=712be128&scoped=true&ts=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"

import "./Layout.vue?vue&type=style&index=0&id=712be128&scoped=true&lang=css"

import exportComponent from "/builds/tmobile/tss/projects/esd/common/techapps-host-ext/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712be128"]])

export default __exports__